import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { CrmLifecycleBoard, CrmSalesBoard } from './CrmLifecycleBoard'
import { CrmAnalytics } from './CrmAnalytics'
import { CrmDemoPipeline } from './CrmDemoPipeline'

/**
 * BOARD HUB (Lee, 26 Oct 2026 — menu restructure): ONE Board destination.
 * Sales Board, Qualification Board, Analytics and Demo Pipeline are tabs on
 * the same page (Lee's notebook: "Sales board & Qualified board tabbed under
 * the same page as Board", "Analytics merged into board as a tab", Demos
 * folded in per his answer). Tab is in the URL (?tab=) so deep links and the
 * old routes' redirects land on the right one; last tab is remembered.
 */

const TABS: Array<{ key: string; label: string }> = [
  { key: 'sales', label: 'Sales' },
  { key: 'qualification', label: 'Qualification' },
  { key: 'analytics', label: 'Analytics' },
  { key: 'demos', label: 'Demo Pipeline' },
]
const STORE = 'wq_board_hub_tab'

export const CrmBoardHub: React.FC = () => {
  const [sp, setSp] = useSearchParams()
  const [tab, setTab] = useState<string>(() => {
    const fromUrl = sp.get('tab')
    if (fromUrl && TABS.some((t) => t.key === fromUrl)) return fromUrl
    try { const v = localStorage.getItem(STORE); if (v && TABS.some((t) => t.key === v)) return v } catch { /* ignore */ }
    return 'sales'
  })
  useEffect(() => {
    try { localStorage.setItem(STORE, tab) } catch { /* ignore */ }
    if (sp.get('tab') !== tab) { sp.set('tab', tab); setSp(sp, { replace: true }) }
  }, [tab]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <div className="shrink-0 flex items-center gap-1 px-4 pt-3 pb-0 bg-surface border-b border-border">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)}
            className={`px-3.5 py-2 rounded-t-lg text-[12.5px] font-bold border-b-2 -mb-px transition-colors ${
              tab === t.key ? 'text-brand-700 border-brand-600 bg-surface' : 'text-txt-tertiary border-transparent hover:text-txt-primary'}`}>
            {t.label}
          </button>
        ))}
      </div>
      {/* key={tab} remounts the pane so switching tabs crossfades (polish pass, 26 Oct 2026). */}
      <div key={tab} className="flex-1 min-h-0 overflow-hidden animate-fade-in">
        {tab === 'sales' && <CrmSalesBoard />}
        {tab === 'qualification' && <CrmLifecycleBoard />}
        {tab === 'analytics' && <div className="h-full overflow-y-auto"><CrmAnalytics /></div>}
        {tab === 'demos' && <div className="h-full overflow-y-auto"><CrmDemoPipeline /></div>}
      </div>
    </div>
  )
}

export default CrmBoardHub
